import React from "react";
import Dashboard from "../../@Components/Dashboard";
import { Col, Content, Grid, Row } from "rsuite";
import { default as DataOutgoingReport } from "../../@Components/Data/OutgoingReport";

const OutgoingReport: React.FC = () => {
  return (
    <Dashboard>
      <Grid fluid>
        <Row className="show-grid">
          <Col className="content-card chart" xs={24}>
            <Content style={{ height: "fit-content" }}>
              <DataOutgoingReport />
            </Content>
          </Col>
        </Row>
      </Grid>
    </Dashboard>
  );
};

export default OutgoingReport;
